// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-tag-template-js": () => import("/opt/buildhome/repo/src/templates/TagTemplate.js" /* webpackChunkName: "component---src-templates-tag-template-js" */),
  "component---src-templates-post-template-js": () => import("/opt/buildhome/repo/src/templates/PostTemplate.js" /* webpackChunkName: "component---src-templates-post-template-js" */),
  "component---src-templates-page-template-js": () => import("/opt/buildhome/repo/src/templates/PageTemplate.js" /* webpackChunkName: "component---src-templates-page-template-js" */),
  "component---src-templates-index-js": () => import("/opt/buildhome/repo/src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-pages-404-js": () => import("/opt/buildhome/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-tags-js": () => import("/opt/buildhome/repo/src/pages/tags.js" /* webpackChunkName: "component---src-pages-tags-js" */)
}

